import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import styles from "../../../ActiveLearningIssue.module.scss";

type Issue4MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue4Material = (props: Issue4MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          「問い」に答えを出す過程で、ターゲットが問題に直面する場面が生まれる。
          <br />
          解決したいのはどのような場面かを想像して入力しよう。
        </p>
        <p className={styles.example}>
          例：主婦→料理をする場面。/おばあさん→買い物に行く場面。/お店の人→お客さんを集める場面。/交通警備員→土日の交通整備の場面。
        </p>
      </div>
      {question1 && <TextInput />}
    </div>
  );
};
export default Issue4Material;
